(function () {
  // Utility: add/remove the animation class and auto-clean
  function pulse(el) {
    if (!el) return;
    el.classList.remove('active_animation'); // reset if mid-animation
    void el.offsetWidth;                     // reflow to restart
    el.classList.add('active_animation');
    el.addEventListener('animationend', () => el.classList.remove('active_animation'), { once: true });
  }

  // Find Product "Add to Cart" button across common markups
  function findATC(root = document) {
    return root.querySelector(
      // Old theme first:
      '.product__form .btn--submit,' +
      // Dawn / OS2.0:
      'product-form [type="submit"],' +
      // Fallback:
      'form[action*="/cart/add"] [type="submit"]'
    );
  }

  // Wire the product ATC button
  function wireProductATC(root = document) {
    const btn = findATC(root);
    console.log(btn)
    if (!btn || btn.dataset.shakeWired === '1') return;
    btn.dataset.shakeWired = '1';

    // Behaviours from old theme:
    btn.addEventListener('mouseenter', () => pulse(btn));

    // OPTIONAL: auto-shake every 6s (comment out to disable)
    const id = setInterval(() => pulse(btn), 6000);
    btn.addEventListener('remove', () => clearInterval(id));

    // Nice extras: shake on click/submit for feedback
    btn.addEventListener('click', () => pulse(btn));
    const form = btn.closest('form');
    if (form) form.addEventListener('submit', () => pulse(btn));
  }

  // Wire the checkout button (cart drawer/page)
  function wireCheckout(root = document) {
    const checkout = root.querySelector('.cart__checkout, [name="checkout"]');
    if (!checkout || checkout.dataset.shakeWired === '1') return;
    checkout.dataset.shakeWired = '1';

    checkout.addEventListener('mouseenter', () => pulse(checkout));

    // OPTIONAL: auto-shake every 6s (comment out to disable)
    const id = setInterval(() => pulse(checkout), 6000);
    checkout.addEventListener('remove', () => clearInterval(id));

    // If your theme fires an update event, this gives a cue
    document.addEventListener('cart:updated', () => pulse(checkout));
  }

  // Observe a cart drawer so we can wire when it appears dynamically
  let drawerObserver;
  function observeCartDrawer() {
    const drawer = document.querySelector('.cart-drawer, .drawer--cart, [data-cart-drawer], #CartDrawer');
    if (!drawer) return;

    if (!drawerObserver) {
      drawerObserver = new MutationObserver(() => wireCheckout(drawer));
    }
    drawerObserver.observe(drawer, { childList: true, subtree: true });

    // Try once immediately as well
    wireCheckout(drawer);
  }

  // Initial run
  document.addEventListener('DOMContentLoaded', () => {
    wireProductATC(document);
    wireCheckout(document);   // covers cart page
    observeCartDrawer();      // covers cart drawer
  });

  // Re-bind when sections load/reload (OS2.0)
  document.addEventListener('shopify:section:load', (e) => {
    wireProductATC(e.target);
    wireCheckout(e.target);
    observeCartDrawer();
  });
})();


